import type { CHIEvent } from "./eventsData";

export type CalendarCostFilter = "all" | "free" | "paid";

/**
 * Registration mode is optional while an event is being prepared. Public event
 * discovery treats a missing mode as complimentary, matching the current site
 * behavior until an organizer explicitly records a paid registration mode.
 */
export function getEventRegistrationCost(event: Pick<CHIEvent, "registrationMode">): Exclude<CalendarCostFilter, "all"> {
  return event.registrationMode === "paid" ? "paid" : "free";
}

export function matchesCalendarCostFilter(
  event: Pick<CHIEvent, "registrationMode">,
  cost: CalendarCostFilter,
): boolean {
  return cost === "all" || getEventRegistrationCost(event) === cost;
}
